<div class="content">

    <!-- Begin dashboard -->
    <div class="container-fluid overflow-auto pt-5 mt-5" style="max-height: 860px;">

        <!-- Page Heading -->
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">User Creation</h1>
        </div>

        <!-- Content Row -->
        <div class="row">
            <div class="col-xl-12 col-md-12 mb-2">
                <div class="card border-left-primary shadow h-100 py-2">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-primary  mb-1">
                                    <form [formGroup]="uCreationForm" (ngSubmit)="onRegister()">
                                        <div class="row">
                                            <div class="col-xl-2 col-md-2 ">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>First Name</mat-label>
                                                        <input matInput formControlName="firstName" pmNoSpace
                                                               minlength="3"
                                                               title="Name at least has 3 characters !">
                                                        <mat-error
                                                                *ngIf="uCreationForm.controls.firstName.errors?.required">
                                                            This field is required !
                                                        </mat-error>
                                                        <mat-error *ngIf="uCreationForm.controls.firstName?.value">Name
                                                            at
                                                            least has 3 characters !
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-md-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Last Name</mat-label>
                                                        <input matInput formControlName="lastName" pmNoSpace>
                                                        <mat-error
                                                                *ngIf="uCreationForm.controls.lastName.errors?.required">
                                                            This field is required !
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-md-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>DOB:</mat-label>
                                                        <input matInput [max]="today" [matDatepicker]="picker"
                                                               formControlName="dob" placeholder="MM/DD/YYYY">
                                                        <mat-datepicker-toggle matSuffix
                                                                               [for]="picker"></mat-datepicker-toggle>
                                                        <mat-datepicker #picker></mat-datepicker>
                                                        <mat-error *ngIf="uCreationForm.controls.dob.errors?.required">
                                                            This field is required !
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-md-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Gender</mat-label>
                                                        <mat-select formControlName="gender" class="text-primary">
                                                            <mat-option class="text-primary" value="Male">Male
                                                            </mat-option>
                                                            <mat-option class="text-primary" value="Female">Female
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                                *ngIf="uCreationForm.controls.gender.errors?.required">
                                                            This field is required !
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-md-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Email</mat-label>
                                                        <input matInput formControlName="email">
                                                        <mat-error
                                                                *ngIf="uCreationForm.controls.email.errors?.required">
                                                            This field is required !
                                                        </mat-error>
                                                        <mat-error *ngIf="uCreationForm.controls.email.errors?.email">
                                                            Require valid email format !
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-md-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>User Name</mat-label>
                                                        <input matInput formControlName="userName" minlength="3"
                                                               title="Name at least has 3 characters!"/>
                                                        <span matSuffix>
                                                        <button *ngIf="uCreationForm.controls.email.valid && !uCreationForm.controls.userName.value " mat-button color="primary"
                                                                (click)="setUsernameAsEmail()"
                                                                style="padding: 0; min-width: auto; font-size: 0.8rem;">
                                                            Same as email?
                                                        </button> <!--(click)="setUsernameAsEmail()"-->
                                                        </span>
                                                        <mat-error
                                                                *ngIf="uCreationForm.controls.userName.errors?.required">
                                                            This field is required!
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div *ngIf="!userId" class="col-xl-2 col-md-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="full-width">
                                                        <mat-label>Password</mat-label>
                                                        <input matInput [type]="hidePassword ? 'password' : 'text'"
                                                               formControlName="password" pmNoSpace pmPasswordPattern placeholder="Enter Password">
                                                        <button *ngIf="uCreationForm.controls.password.value" mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()">
                                                            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                                                        </button>
                                                        <mat-error *ngIf="uCreationForm.controls.password.errors?.required">
                                                            This field is required!
                                                        </mat-error>
                                                        <mat-error *ngIf="uCreationForm.controls.password.errors?.pattern">
                                                            Password must be at least 8 characters, contain an uppercase letter, a lowercase letter, a number, and a special character.
                                                        </mat-error>
                                                        <div class="checkbox-container">
                                                            <mat-checkbox formControlName="temporary"
                                                                          [checked]="uCreationForm.controls.temporary.value || false"
                                                                          (change)="show($event)"
                                                                          class="temp-checkbox"
                                                                          [disabled]="!uCreationForm.controls.password.value">
                                                                Temporary?
                                                            </mat-checkbox>
                                                        </div>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                           <div *ngIf="userType == 'INTERNAL'" class="col-xl-2 col-md-2">
                                                <div *ngIf="userType == 'INTERNAL'" class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>User-Type</mat-label>
                                                        <mat-select formControlName="userType" class="text-primary">
                                                            <mat-option class="text-primary"
                                                                        *ngFor="let items of userTypeArray"
                                                                        [value]="items.value" [ngClass]="{'disabled-option': items.value === 'INTERNAL' && isProvider}">{{items.viewValue}}</mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                                *ngIf="uCreationForm.controls.userType.errors?.required">
                                                            This field is required !
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div *ngIf="userType == 'INTERNAL'" class="col-xl-2 col-md-2">
                                                <div *ngIf="userType == 'INTERNAL'" class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Client Id</mat-label>
                                                        <mat-select formControlName="clientIds" class="text-primary" multiple>
                                                            <mat-option class="text-primary"
                                                                        *ngFor="let items of clientList"
                                                                        [value]="items.id">{{items.name}}</mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                                *ngIf="uCreationForm.controls.clientIds.errors?.required">
                                                            This field is required !
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-md-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Group</mat-label>
                                                        <mat-select formControlName="group" (selectionChange)="getGroupRoles(this.uCreationForm.controls.group.value)">
                                                            <mat-option *ngFor="let item of groupArray" [value]="item.groupName" >
                                                                {{ item.groupName }}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                           <div  class="col-xl-2 col-md-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Group Role</mat-label>
                                                        <mat-select  formControlName="roles" multiple >
                                                            <mat-option *ngFor="let role of totalRoles" [value]="role.realmName">
                                                                {{ role.realmName }}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error *ngIf="uCreationForm.controls.roles.errors?.required">
                                                            This field is required!
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-md-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Department</mat-label>
                                                        <input matInput formControlName="department">
                                                        <mat-error
                                                                *ngIf="uCreationForm.controls.department.errors?.required">
                                                            This field is required !
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                                
                                        </div>
                                        <button type="button" routerLink="/user"
                                                class="btn btn-secondary float-end  waves-effect waves-light">Cancel
                                        </button>
                                        <button *ngIf="!userId" class="btn btn-outline-light btn-lg px-5 float-right"
                                                mat-raised-button color="primary" type="submit"
                                                [disabled]="!uCreationForm.valid">Create
                                        </button>
                                        <button *ngIf="userId" class="btn btn-outline-light btn-lg px-5 float-right"
                                                mat-raised-button color="primary" type="submit"
                                                [disabled]="!uCreationForm.valid">Update
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

